import React from "react";
import { AppContext } from "../../App";
import { useContext } from "react";
import { Link } from 'react-router-dom';
import { NavLink } from "react-router-dom";
import { useState, useEffect } from "react";

//Import Swiper React components
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Pagination } from 'swiper/modules';

//Import FontAwesome
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAngleRight, faAngleDown, faBars } from "@fortawesome/free-solid-svg-icons";
import { faFacebookF, faTiktok, faInstagram, faWhatsapp } from "@fortawesome/free-brands-svg-icons";

// Import CSS
import './home.css';

// Import Components
import  { SocialMediaComponents } from '../socialMediaComponents/socialMediaComponents';
import { FooterComponent } from '../footerComponent/footerComponent.js';
import CardComponents from '../cardComponents/cardComponents'
import MainMenuBar from '../mainMenuBar/mainMenuBar'


// import Assets
import PortadaTopHome from '../../assets/homeAssets/portadaTopHome.jpg';
import LogoMonitronix from '../../assets/homeAssets/logo-monitronix.svg';
import photoQuinesSomos from '../../assets/homeAssets/photo-quienes-somos.svg';
import BannerHome from '../../assets/homeAssets/BannerHome/BannerHomeParalax.jpg';
import LogoBannerMonitronix from '../../assets/homeAssets/BannerHome/Logo-banner-monitronix.svg';
import PhotoServicio1 from '../../assets/homeAssets/photo-servicios/photo-serv-1.jpg';
import PhotoServicio2 from '../../assets/homeAssets/photo-servicios/photo-serv-2.jpg';
import PhotoServicio3 from '../../assets/homeAssets/photo-servicios/photo-serv-3.jpg';
import IconServ1 from '../../assets/homeAssets/iconosServicios/icon-serv-1.svg';
import IconServ2 from '../../assets/homeAssets/iconosServicios/icon-serv-2.svg';
import IconServ3 from '../../assets/homeAssets/iconosServicios/icon-serv-3.svg';
import IconServ4 from '../../assets/homeAssets/iconosServicios/icon-serv-4.svg';
import IconMarca1 from '../../assets/homeAssets/iconos-marcas/iconMarca1.svg';
import IconMarca2 from '../../assets/homeAssets/iconos-marcas/iconMarca2.svg';
import IconMarca3 from '../../assets/homeAssets/iconos-marcas/iconMarca3.svg';
import IconMarca4 from '../../assets/homeAssets/iconos-marcas/iconMarca4.svg';
import IconMarca5 from '../../assets/homeAssets/iconos-marcas/iconMarca5.svg';
import IconMarca6 from '../../assets/homeAssets/iconos-marcas/iconMarca6.svg';
import CollageTech1 from '../../assets/homeAssets/Collage-Tech/collageTech1.png';
import CollageTech2 from '../../assets/homeAssets/Collage-Tech/collageTech2.png';
import CollageTech3 from '../../assets/homeAssets/Collage-Tech/collageTech3.png';

 
function Home() {

    //State Scroll Bar
    const [visible, setVisible] = useState(false);

        useEffect(() => {
            const handleScroll = () => {
            if (window.scrollY > 300) {
                setVisible(true);
            } else {
                setVisible(false);
            }
            };

            window.addEventListener("scroll", handleScroll);
            return () => window.removeEventListener("scroll", handleScroll);
        }, []);

        //State Open Close Menú Panel
        const [isOpenMD, setIsOpenMD] = useState(true)
        console.log(isOpenMD);

    const { 
        
        // Photo Soluciones
        photoSoluciones1,
        photoSoluciones2,
        photoSoluciones3,
        photoSoluciones4,
        photoSoluciones5,
        photoSoluciones6,
        photoSoluciones7,
        photoSoluciones8,
        // Title Soluciones
        titleSolucion1,
        titleSolucion2,
        titleSolucion3,
        titleSolucion4,
        titleSolucion5,
        titleSolucion6,
        titleSolucion7,
        titleSolucion8,
        // Text Soluciones
        textSolucion1,
        textSolucion2,
        textSolucion3,
        textSolucion4,
        textSolucion5,
        textSolucion6,
        textSolucion7,
        textSolucion8,
        // Props Page Tecnología 
        bkGallerieTech,
        productTech

    } = useContext(AppContext);

    // Background Portada Home
    const isMobilePortadaHome = window.innerWidth <= 780;
    // const isSmartPhonePortadaHome = window.innerWidth <= 580;

    const styleBkHomePortada = {
    backgroundImage: `url(${PortadaTopHome})`,
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    width: '100%',
    height: isMobilePortadaHome ? '60vh' : '460px',
    // height: isSmartPhonePortadaHome ? '60vh' : '460px',
    };

    const isMobileBannerHome = window.innerWidth <= 780;

     // Background Banner Home
    const styleBkBannerHome = {
        backgroundImage: `url(${BannerHome})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundAttachment: "fixed",
        width: '100%',
        height: isMobileBannerHome ? '320px' : '360px',
    }

     // Background Servicios Home
    const styleBkPhoto1 = {
        backgroundImage: `url(${PhotoServicio1})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        width: '100%',
        height: '260',
    }

    const styleBkPhoto2 = {
        backgroundImage: `url(${PhotoServicio2})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        width: '100%',
        height: '260',
    }

    const styleBkPhoto3 = {
        backgroundImage: `url(${PhotoServicio3})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        width: '100%',
        height: '260',
    }


    return (

        <div className="home-container"> 


            {/* CONTENEDOR MENU SLIDE DOWN */}
            <div className="conteiner-menu-slide-down">

                <div className="box-button-menu-slide-down">

                    <button className="open-close-slide-down"> <FontAwesomeIcon icon={faBars} onClick={() => setIsOpenMD(!isOpenMD)}/>  </button>     

                </div>

                <div className="box-social-media-icons"> < SocialMediaComponents/> </div>

            </div>

            {/* ---------------- */}


            {/* Menú Scroll Bar */}
            <div className={`menu-scroll-bar-container ${visible ? "visible" : ""}`}>
                   
                <div className="box-scroll-bar">

                    <nav className="container-scroll-bar">
                        <NavLink 
                            to="/quienes-somos" 
                            className={({ isActive }) => 
                            isActive 
                                ? "menu-scroll-bar menu-bar-quienes-somos active-scroll-bar" 
                                : "menu-scroll-bar menu-bar-quienes-somos"
                            }
                        >
                            QUIENES SOMOS
                        </NavLink>

                        <NavLink 
                            to="/soluciones" 
                            className={({ isActive }) => 
                            isActive 
                                ? "menu-scroll-bar menu-scroll-bar-soluciones active-scroll-bar" 
                                : "menu-scroll-bar menu-scroll-bar-soluciones"
                            }
                        >
                            SOLUCIONES
                        </NavLink>

                        <NavLink 
                            to="/tecnologia" 
                            className={({ isActive }) => 
                            isActive 
                                ? "menu-scroll-bar menu-scroll-bar-tecnologia active-scroll-bar" 
                                : "menu-scroll-bar menu-scroll-bar-tecnologia"
                            }
                        >
                            TECNOLOGÍA
                        </NavLink>

                        <NavLink 
                            to="/contactanos" 
                            className={({ isActive }) => 
                            isActive 
                                ? "menu-scroll-bar menu-scroll-bar-contactenos active-scroll-bar" 
                                : "menu-scroll-bar menu-scroll-bar-contactenos"
                            }
                        >
                            CONTÁCTANOS
                        </NavLink>

                    </nav>

                </div>
                
                <div className="box-social-media-scroll-bar">

                    <SocialMediaComponents/>

                </div>

            </div>
            {/* -------------- *** -------------- */}
        

            {/* // Sección Portada Top Home */}
            <div className="top-portada-home" style={styleBkHomePortada}>

                {/* Menú panel slide top down home */ }
                <div className={ isOpenMD ? 'menu-slide-home-is-close' : 'menu-slide-home-is-open'  }>
                
                    <nav className="conteiner-nav-links-home">
                        <NavLink to='/quienes-somos'    className={`menu-home-slide-link slide-link-1`}>QUIENES SOMOS</NavLink>
                        <NavLink to='/soluciones'       className={`menu-home-slide-link slide-link-2`}>SOLUCIONES</NavLink>
                        <NavLink to='/tecnologia'       className={`menu-home-slide-link slide-link-3`}>TECNOLOGÍA</NavLink>
                        <NavLink to='/contactanos'      className={`menu-home-slide-link slide-link-4`}>CONTÁCTANOS</NavLink>
                    </nav>
            
                </div> 

                <div className="box-redes-portada"> <SocialMediaComponents/> </div>

                <div className="box-logo-monitronix">   

                    <img className="logo-monitronix-home" src={LogoMonitronix} alt="Monitronix SAS" />

                </div>

                <MainMenuBar/>

            </div>
        

            {/* // Sección Quienes Sommos */}
            <div className="container-quienes-somos">

                <div className="box-info-quienes-somos">

                    <h2 className="title-quienes-somos">MONITRONIX SAS</h2>

                    <p className="texto-quines-somos">
                        Somos una empresa de tecnología en seguridad 
                        activa a la vanguardia de soluciones en sistemas de 
                        videovigilancia, monitoreo activo 24/7, sistemas de 
                        alarmas remotas con guardianía virtual y vídeo 
                        verificación. Sistemas de control de acceso 
                        automatizados y todo para la seguridad de su familia, 
                        negocio o empresa. 
                    </p>

                    <Link to="/quienes-somos" className="link-q-somos">Más sobre nosotros
                        <FontAwesomeIcon className='arrowBotton' icon={faAngleRight} />

                    </Link>

                </div>

                <div className="box-photo-quienes-somos"> 
                    <img className="photo-quienes-somos" src={photoQuinesSomos} alt="Monitronix SAS - Quiénes Somos" />

                </div>

                <div className="box-img-quienes-somos"></div>
            </div>



            {/* // Sección Soluciones */}
            
            <div className="conteiner-soluciones">


                <div className="box-title-text-soluciones">

                    <h2 className="title-soluciones-home">SOLUCIONES EN SEGURIDAD ELECTRÓNICA</h2>
                    <p className="sub-title-soluciones">Productos y servicios con tecnología de vanguardia a tu cuidado</p>

                </div>

                
                <div className="box-cards-soluciones">

                    <Swiper
                        modules={[Navigation, Pagination]}
                        spaceBetween={0}       // separación entre slides
                        slidesPerView={3}       // cuántos se ven al mismo tiempo
                        centeredSlides={true}
                        slidesOffsetBefore={40}  // padding al inicio
                        slidesOffsetAfter={0}   // padding al final 
                        navigation              // flechas de navegación
                        pagination={{ clickable: true }} // puntos de paginación
                        breakpoints={{
                                0: {
                                    slidesPerView: 1,   // desde 0px hasta 820px
                                    centeredSlides: true,
                                    centerInsufficientSlide: true,
                                    slidesOffsetBefore: 40,
                                    slidesOffsetAfter: 0,
                                },


                                380: {
                                    slidesPerView: 1,   // desde 0px hasta 820px
                                    centeredSlides: true,
                                    centerInsufficientSlide: true,
                                    slidesOffsetBefore: 50,
                                    slidesOffsetAfter: 0,
                                },


                                680: {
                                    slidesPerView: 2, 
                                    spaceBetween: 0,       // desde 0px hasta 820px
                                    centeredSlides: false,
                                    slidesOffsetBefore: 50,
                                    slidesOffsetAfter: 0,
                                },


                                780: {
                                    slidesPerView: 2, 
                                    spaceBetween: 0,       // desde 0px hasta 820px
                                    centeredSlides: false,
                                    slidesOffsetBefore: 60,
                                    slidesOffsetAfter: 0,
                                },



                            
                                980: {
                                    slidesPerView: 3,   // desde 821px en adelante
                                    centeredSlides: false,
                                    slidesOffsetBefore: 40,
                                    slidesOffsetAfter: 0,
                                },
                            
                            }}
                        >

                        <SwiperSlide>
                                {/* //Card Component 1 */}
                            <CardComponents 
                                
                                photoSolution={photoSoluciones1}
                                titleSolution={titleSolucion1}
                                textSolucion={textSolucion1}

                            />

                        </SwiperSlide>


                        <SwiperSlide>
                            {/* //Card Component 2 */}
                            <CardComponents 
                                
                                photoSolution={photoSoluciones2}
                                titleSolution={titleSolucion2}
                                textSolucion={textSolucion2}

                            />

                        </SwiperSlide>



                        <SwiperSlide>
                                {/* //Card Component 3 */}
                            <CardComponents 
                                
                                photoSolution={photoSoluciones3}
                                titleSolution={titleSolucion3}
                                textSolucion={textSolucion3}

                            />

                        </SwiperSlide>


                        <SwiperSlide>
                        
                            {/* //Card Component 4 */}
                            <CardComponents 
                                
                                photoSolution={photoSoluciones4}
                                titleSolution={titleSolucion4}
                                textSolucion={textSolucion4}

                            />

                        </SwiperSlide>


                        <SwiperSlide>
                                {/* //Card Component 5 */}
                            <CardComponents 
                                
                                photoSolution={photoSoluciones5}
                                titleSolution={titleSolucion5}
                                textSolucion={textSolucion5}

                            />

                        </SwiperSlide>


                        <SwiperSlide>
                                {/* //Card Component 6 */}
                            <CardComponents 
                                
                                photoSolution={photoSoluciones6}
                                titleSolution={titleSolucion6}
                                textSolucion={textSolucion6}

                            />

                        </SwiperSlide>

                        <SwiperSlide>
                                {/* //Card Component 7 */}
                            <CardComponents 
                                
                                photoSolution={photoSoluciones7}
                                titleSolution={titleSolucion7}
                                textSolucion={textSolucion7}

                            />

                        </SwiperSlide>


                        <SwiperSlide>
                                {/* //Card Component 8 */}
                            <CardComponents 
                                
                                photoSolution={photoSoluciones8}
                                titleSolution={titleSolucion8}
                                textSolucion={textSolucion8}

                            />

                        </SwiperSlide>

                    </Swiper>

                </div>


                <Link to="/soluciones" className="link-soluciones">Más sobre nosotros
                    <FontAwesomeIcon className='arrowBotton' icon={faAngleRight} />

                </Link>

            </div>



            {/* // Banner Monitronix */}
            <div className="banner-monitronix-container" style={styleBkBannerHome}> 

                <img className="logo-monitronix-robot" src={LogoBannerMonitronix} alt="Monitronix SAS"></img>

            </div>


            {/* // Seccion Servicio Home */}
            <div className="container-servicio-home"> 

                <div className="box-info-servicio-bloque-A">
                    
                    <div className="box-text-info-servicio"> 

                        <h2 className="title-servicio-home">SERVICIO QUE<br></br> <span className="text-celeste text-serv-celeste">MARCA LA DIFERENCIA</span> </h2>
                        <p className="text-servicio-home">
                            Somos una empresa  de seguridad con un 
                            enfoque de servicio integral que ofrece 
                            asesoramiento, respaldo y garantía en 
                            cada proyecto.
                        </p>

                    </div>

                    <div className="box-photos-servicios"> 

                        <div className="photo-servicio photo-serv-1" style={styleBkPhoto1}></div>
                        <div className="photo-servicio photo-serv-2" style={styleBkPhoto2}></div>
                        <div className="photo-servicio photo-serv-3" style={styleBkPhoto3}></div>

                    </div>

                  

                </div>
                    
                <div className="box-info-servicio-bloque-B"> 

                    <div  className="box-icon-text box-icon-text-1">
                        <img className="icon-serv icon-serv-1" src={IconServ1} alt="Asesoramiento Técnico"></img>
                        <p>Asesoramiento <br></br>Técnico</p>
                    </div>

                    <div  className="box-icon-text box-icon-text-2">
                        <img className="icon-serv icon-serv-3" src={IconServ2} alt="Instalación Grantizada"></img>
                        <p>Instalación <br></br>Grantizada </p>
                    </div>

                    <div  className="box-icon-text box-icon-text-3">
                        <img className="icon-serv icon-serv-3" src={IconServ3} alt="Servicio Técnico Profesional"></img>
                        <p>Servicio Técnico <br></br>Profesional</p>
                    </div>

                    <div  className="box-icon-text box-icon-text-4">
                        <img className="icon-serv icon-serv-4" src={IconServ4} alt="Monitoreo con alerta activa 24/7"></img>
                        <p>Monitoreo con <br></br>alerta activa 24/7</p>
                    </div>

                </div>


                <div className="box-button-to-servTec">
    
                    <a 
                        className="link-to-serv-tec" 
                        href="https://wa.me/593967124133" 
                        target="_blank" 
                        rel="noopener noreferrer"
                        
                    > <FontAwesomeIcon icon={faWhatsapp}/> <p className="text-button-serv-tec">Servicio técnico </p> </a>
                            
                </div>


            </div>


            {/* // Seccion Tecnología */}
            <div className="container-tecnologia"> 

                <div className="title-tecnologia">
                    <h2 className="title-tec-home">TECNOLOGÍA <br></br> <span className="text-celeste text-celeste-tech">DE VANGUARDIA</span></h2>
                </div>

                <div className="box-collage-tecnologia"> 
                    <img className="photo-collage photo-collage-1" src={CollageTech1} alt="Tecnología Monitronix SAS"/>
                    <img className="photo-collage photo-collage-2" src={CollageTech2} alt="Tecnología Monitronix SAS"/>
                    <img className="photo-collage photo-collage-3" src={CollageTech3} alt="Tecnología Monitronix SAS"/>
                </div>

                <div className="box-text-tecnologia"> 

                    <p className="text-info-tech">
                        <span>MONITRONIX SAS</span> ofrece tecnología de vanguardía en 
                        cada proyecto. Nuestras soluciones en seguridad electrónica están 
                        respaldadas con equipos de última generación en las marcas más 
                        reconocidas del mercado. 
                    </p>

                </div>


                <div className="box-marcas-tecnologia"> 

                    <img className="logo-marca-tec logo-marca-1" src={IconMarca1} alt="Hikvision Monitronix SAS"/>
                    <img className="logo-marca-tec logo-marca-2" src={IconMarca2} alt="ahua Monitronix SAS"/>
                    <img className="logo-marca-tec logo-marca-3" src={IconMarca3} alt="ZKTeco Monitronix SAS"/>
                    <img className="logo-marca-tec logo-marca-4" src={IconMarca4} alt="DSC NeoTecnología Monitronix SAS"/>
                    <img className="logo-marca-tec logo-marca-5" src={IconMarca5} alt="Marca Tecnología Monitronix SAS"/>
                    <img className="logo-marca-tec logo-marca-6" src={IconMarca6} alt="Marca Tecnología Monitronix SAS"/>
                    

                </div>

                <div className="box-boton-tecnologia"> 

                    <Link to="/tecnologia" className="link-tecnologia">Nuestra Tecnología
                        <FontAwesomeIcon className='arrowBotton' icon={faAngleRight} />

                    </Link>

                </div>


                <div className="box-text-asesoramiento"> 
                    <p className="text-asesoramiento-tech">Solicita asesoramiento personalizado sin costo.</p>
                    <p className="text-contactanos">CONTÁCTANOS</p>
                    <span><FontAwesomeIcon icon={faAngleDown} /></span>  

                </div>


            </div>


            {/* // Seccion Footer */}
            <div className="footer-container-home">
                 <FooterComponent />

            </div>
 

        </div>

   );
};

export default Home;